<template>
    <input
        ref="inputRef"
        :class="{ 'border-red-500 dark:border-red-500': form && form.errors.hasOwnProperty(name), 'px-3 py-2': !noPadding }"
        :value="formattedValue"
        class="border focus:ring-indigo-400 focus:border-indigo-400 border-gray-300 rounded-md block w-full sm:text-sm sm:leading-5 dark:bg-gray-700 dark:border-gray-800 dark:text-gray-300"
    />
</template>

<script>
import i18n from '@/Plugins/i18n';
import useCurrencyInput from 'vue-currency-input';
import {watch} from '@vue/composition-api';

export default {

    props: {
        value: {
            required: true,
        },
        form: Object,
        noPadding: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        inputValue: {
            get() {
                return this.value ? parseInt(this.value) : null;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },

    setup(props) {
        let options = {
            'locale': i18n.locale,
            'currency': 'EUR',
            'precision': 0,
            'exportValueAsInteger': true,
        };

        const {formattedValue, inputRef, setValue} = useCurrencyInput(options);

        watch(() => props.value, (value) => { // Vue 2: props.value
            setValue(value);
        });

        return {inputRef, formattedValue};
    },
};
</script>
